import api from '@/factories/api';

export default {
  namespaced: true,

  state: {
    views: [],
    loading: false,
    loaded: false,
  },

  getters: {
    views: (state) => state.views,
    loading: (state) => state.loading,
    loaded: (state) => state.loaded,
  },

  mutations: {
    setViews(state, views) {
      state.views = views;
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
    setLoaded(state, loaded) {
      state.loaded = loaded;
    },
  },

  actions: {
    async loadViews({ commit, state }) {
      if (state.loaded || state.loading) return;

      commit('setLoading', true);
      try {
        const views = await api().get('portal/views');
        commit('setViews', Array.isArray(views) ? views : []);
      } catch (err) {
        console.error('Failed to load portal views', err);
        commit('setViews', []);
      } finally {
        commit('setLoading', false);
        commit('setLoaded', true);
      }
    },
  },
};
